






















































import Card from '@/components/Card.vue'
import Table from '@/components/Table.vue'
import {
  getTopUpAgents,
  getTopUpAgentById,
  transferTopUpCredit,
} from '@/api/Topup/topup.api'
import { TableHeader, Params } from '@/utils/interfaces'
import ActionButton from '@/components/ActionButton.vue'
import {
  RemoveCreditDTO,
  TopUpAgent,
  TopUpPrice,
} from '@/utils/interfaces/topup.interface'
import TransfertopUpCreditDialog from '@/components/Services/TopUps/TransfertopUpCreditDialog.vue'
import { message } from '@/store/modules/notifications'
import UsersFilter from '@/components/Agency/Users/UsersFilter.vue'
import { tableHandler } from '@/utils/mixins/tableHandler'
import RemoveNetCredit from '@/components/Services/TopUps/RemoveNetCredit.vue'
import FlatCard from '~/components/FlatCard.vue'
import FlatTable from '~/components/FlatTable.vue'

export default tableHandler<TopUpPrice>().extend({
  components: {
    appCard: Card,
    appTable: Table,
    appActionButton: ActionButton,
    appTransferTopUpCreditDialog: TransfertopUpCreditDialog,
    appUsersFilter: UsersFilter,
    appRemoveNetCredit: RemoveNetCredit,
    FlatCard,
    FlatTable,
  },
  data() {
    return {
      getAgents: (params?: Params) =>
        getTopUpAgents({ ...params, not_self: true }),
      headers: [
        {
          text: this.$t('agent'),
          value: 'username',
        },
        {
          text: this.$t('credit'),
          value: 'topup_credit',
        },
        {
          text: this.$t('transfer'),
          value: 'actions',
        },
      ] as TableHeader[],
      from: {} as TopUpAgent,
      to: {} as TopUpAgent,
      dialog: false,
      loading: false,
    }
  },
  methods: {
    onRefresh(e: RemoveCreditDTO, item: TopUpAgent) {
      item.topup_credit = 0
      this.from.topup_credit = Number(e.credit)
    },
    onTransfer(item: TopUpAgent) {
      this.to = item
      this.dialog = true
    },
    async action(
      method: 'send' | 'receive',
      credit: number,
      description?: string,
    ) {
      let newFrom
      let newTo
      if (method === 'send') {
        newFrom = this.from
        newTo = this.to
      } else {
        newTo = this.from
        newFrom = this.to
      }
      await transferTopUpCredit({
        from_agent: newFrom.uuid,
        to_agent: newTo.uuid,
        credit,
        description,
      })
      const payload: message = {
        text: this.$t('topup.credit-transfer'),
        title: this.$t('topup.credit-transfer'),
        color: 'success',
        icon: 'mdi-bank-transfer',
        description: `${this.$t('transferred')} $ ${credit} ${this.$t(
          'from',
        )} ${newFrom.username} ${this.$t('to')} ${newTo.username}`,
      }
      this.$store.commit('notifications/pushMessage', payload)
      this.onSuccess({ method: method, amount: credit })
      return true
    },
    onSuccess(payload: { amount: number; method: 'send' | 'receive' }) {
      if (payload.method === 'send') {
        this.from.topup_credit = Number(
          (Number(this.from.topup_credit) - Number(payload.amount)).toFixed(2),
        )
        this.to.topup_credit = Number(
          (Number(this.to.topup_credit) + Number(payload.amount)).toFixed(2),
        )
      } else {
        this.from.topup_credit = Number(
          (Number(this.from.topup_credit) + Number(payload.amount)).toFixed(2),
        )
        this.to.topup_credit = Number(
          (Number(this.to.topup_credit) - Number(payload.amount)).toFixed(2),
        )
      }
    },
  },
  async mounted() {
    try {
      this.loading = true
      const response = await getTopUpAgentById(this.$store.getters.profile.uuid)
      this.from = response.data
    } finally {
      this.loading = false
    }
  },
})
